import { render, staticRenderFns } from "./FormAddPost.vue?vue&type=template&id=62313cce&scoped=true"
import script from "./FormAddPost.vue?vue&type=script&lang=js"
export * from "./FormAddPost.vue?vue&type=script&lang=js"
import style0 from "./FormAddPost.vue?vue&type=style&index=0&id=62313cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62313cce",
  null
  
)

export default component.exports